'use strict';
var util = angular.module('gymsystem.util');
util.factory('BankAccount', ['$modal', '$q', 'server', 'util', function ($modal, $q, server, util) {
        var BankAccount = {};
        var bankAccountName = {
            bankgiro: 'Bankgiro',
            /*plusgiro: 'Plusgiro', not implemented */
            bankaccount: 'Bank account'
        };
        BankAccount.selectDialog = function (user) {
            return $q.promise(function (resolve, reject) {
                BankAccount.changeDialog(user, { selectMode: true }).result.then(function (value) {
                    resolve(value);
                }, reject);
            });
        };
        BankAccount.getFirst = function (user) {
            return $q.promise(function (resolve, reject) {
                server.post2('/api/bankaccount/get/first', { user_id: user.id }).then(function (account) {
                    resolve(account && BankAccount.transform(account));
                }, reject);
            });
        };
        BankAccount.changeDialog = function (user, option) {
            if (option === void 0) { option = {}; }
            return $modal.open({
                templateUrl: 'components/bankaccount/bankaccount.html',
                controller: ['$scope', 'util', 'server', 'live', 'alertProvider', 'confirm', '$filter', '$rootScope', 'banks',
                    function ($scope, util, server, live, alertProvider, confirm, $filter, $rootScope, banks) {
                        var editPermission = $scope.editPermission = $rootScope.hasPermission('Bank account');
                        $scope.add = function () {
                            change({ isNew: true });
                        };
                        $scope.close = function () {
                            if ($scope.active)
                                $scope.active = false;
                            else
                                $scope.$dismiss();
                        };
                        $scope.saving = false;
                        $scope.save = function () {
                            var obj = util.getSubmitItem($scope.fields);
                            obj.id = $scope.active.id;
                            obj.user_id = user.id;
                            $scope.saving = true;
                            server.post2($scope.active.isNew ? '/api/bankaccount/add' : '/api/bankaccount/change', { account: obj }).then(function (response) {
                                $scope.active = null;
                            }, function () {
                                alertProvider.show('error', 'Failed to save');
                            })["finally"](function () { return $scope.saving = false; });
                        };
                        var select = function (a) {
                            if (!option.selectMode)
                                return;
                            $scope.$close(a);
                        };
                        var change = function (a) {
                            $scope.active = a;
                            util.setValues($scope.fields, a);
                            clearingNumberChange();
                        };
                        var remove = function (a) {
                            var message = $filter('translate')('Are you sure you want to remove {0}').format(a.name);
                            confirm.show(message, { ladda: true }).then(function (resolve) {
                                server.post2('/api/bankaccount/remove', { id: a.id })["catch"](function () {
                                    alertProvider.show('error', 'Failed to remove');
                                })["finally"](resolve);
                            });
                        };
                        $scope.fields = [];
                        $scope.active = null;
                        $scope.config = {
                            api: {
                                url: '/api/bankaccount/get',
                                args: { user_id: user.id },
                                triggers: [{
                                        type: 'bankaccount',
                                        condition: function (a) { return a.user_id == user.id; }
                                    }],
                                transform: BankAccount.transform
                            },
                            rowClick: select,
                            hideSearch: true,
                            columns: [
                                { field: 'type', title: 'Type', getValue: function (a) { return $filter('translate')(bankAccountName[a.type]); } },
                                { field: 'name', title: 'info' }
                            ],
                            buttons: [
                                { title: 'Change', buttonClass: 'btn-warning', onClick: change, visible: function () { return editPermission; } },
                                { title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: function () { return editPermission; } },
                                { visible: function () { return option.selectMode; }, title: 'Choose', buttonClass: 'btn-success', onClick: select }
                            ]
                        };
                        var getClearingNumber = function () {
                            return _.findWhere($scope.fields, { name: 'clearingnumber' }).value;
                        };
                        var types = Object.keys(bankAccountName);
                        var onType = function (t) {
                            return function () { return $scope.fields[0].value == t; };
                        };
                        $scope.fix = function () {
                            return $scope.addform.$valid;
                        };
                        function clearingNumberChange() {
                            var bank, clearingNumber = getClearingNumber();
                            if (clearingNumber) {
                                clearingNumber = String(clearingNumber).substring(0, 4);
                                bank = banks.getBank(clearingNumber);
                            }
                            else {
                                bank = void 0;
                            }
                            _.findWhere($scope.fields, { name: 'bank' }).value = bank ? bank.name : '';
                        }
                        $scope.fields = [
                            { name: 'type', title: 'Type', required: true, type: 'select', options: function () { return types; }, getName: function (t) { return bankAccountName[t]; } },
                            { name: 'clearingnumber', title: 'Clearing number', required: true, type: 'clearingNumber', max: 99999, change: clearingNumberChange, visible: onType('bankaccount') },
                            { name: 'bank', title: 'Bank', required: false, type: 'label', visible: onType('bankaccount') },
                            { hint: 'BANK_ACCOUNT_HINT', visible: onType('bankaccount') },
                            { name: 'account', title: 'Bank account number', required: true, type: 'bankAccountNumber2', getClearingNumber: getClearingNumber, visible: onType('bankaccount') },
                            { name: 'bankgironumber', title: 'BG-account', required: true, type: 'bankgiroNumber', visible: onType('bankgiro') },
                            { name: 'plusgironumber', title: 'Account', required: true, type: 'bankgiroNumber', visible: onType('plusgiro') }
                        ];
                        $scope.getTitle = function (name) {
                            if (name) {
                                return _.findWhere($scope.fields, { name: $rootScope.getRealFormName(name) }).title;
                            }
                        };
                    }]
            });
        };
        BankAccount.transform = function (obj) {
            if (Array.isArray(obj))
                return obj.map(BankAccount.transform);
            if (!obj.fullname) {
                obj.fullname = util.t(bankAccountName[obj.type]) + ' ' + obj.name;
            }
            return obj;
        };
        return BankAccount;
    }]);
